<template>
    <div class="enhancify grid-module" ref="module">
      <div class="grid-module__filter">
        <div class="modern-form-group sm-modern-form-group">
          <div class="floating-button">
            <b-button
                class="is-success sm-show"
                :disabled="isFormDisabled"
                @click="onResubscribe"
                position="is-right">
              {{'resubscribe' | upper}}
            </b-button>
            <b-button
                class="is-success sm-show"
                :disabled="isFormDisabled"
                @click="onUnsubscribe"
                position="is-right">
              {{'unsubscribe' | upper}}
            </b-button>
          </div>
        </div>
        <div class="modern-form-group">
          <div class="modern-input-labeled">
            <div class="modern-input-controlled">
              <ModernInput type="search"
                           @enter="doSearch"
                           placeholder="Search by contacts"
                           v-model="filters.searchText"/>
              <div class="modern-input-control">
                <button class="modern-button" :disabled="isFormDisabled" @click="doSearch" >
                  <i class="mdi mdi-magnify"></i>
                </button>
              </div>
            </div>
          </div>
          <div class="modern-input-labeled">
            <label for="sourceFilter" style="white-space: nowrap">Source</label>
            <ModernSelect
                id="sourceFilter"
                v-model="filters.source"
                :options="sources"
            />
          </div>
          <div class="floating-button">
            <b-button
                class="is-success sm-hide"
                :disabled="isFormDisabled"
                @click="onResubscribe"
                position="is-right">
              {{'resubscribe' | upper}}
            </b-button>
            <b-button
                class="is-success sm-hide"
                :disabled="isFormDisabled"
                @click="onUnsubscribe"
                position="is-right">
              {{'unsubscribe' | upper}}
            </b-button>
          </div>
        </div>
      </div>
      <section class="data-grid">
        <template v-if="!data.length">
          <b-table
              class="modern-table"
              height="100%"
              :columns="columns"
              :loading="loading">
            <template #header="{ column }">
              <div :class="[{'top-sticked': isTopSticky}, column['thclass'],
         'modern-table-header-label']">
                {{ column['label'] }}
              </div>
            </template>

            <template #empty v-if="!loading">
              <div style="padding-top: 1em; overflow: hidden; text-align: center">
          <span class="icon">
            <i class="fal fa-frown fa-3x"></i>
          </span>
                <p>Nothing here</p>
              </div>
            </template>
          </b-table>
        </template>
        <template v-else>
          <ModernTable
              class="modern-table"
              :loading="loading"
              :per-page="filters.limit"
              :total="total"
              :current-page.sync="filters.page"
              :data="data"
              paginated
              hoverable
              pagination-size="is-medium"
              backend-pagination
              backend-sorting
              :defaultSort="filters.sortField"
              @sort="onSort"
          >
            <template #header="{ column }">
              <div :class="[{'top-sticked': isTopSticky}, column['thclass'],
         'modern-table-header-label']"
                   :ref="column['field']">
                {{ column['label'] }}
              </div>
            </template>
            <template #default="{ row }">

              <b-table-column label="E-mail"
                              field="email"
                              width="60%"
                              cell-class="email-column"
                              style="text-align: left" sortable>
                <span >{{ row['email'] }}</span>
              </b-table-column>
              <b-table-column label="Date"
                              field="date"
                              width="20%"
                              style="background: #f2f5f6; text-align: left" sortable>
                <span >{{ row['date'] }}</span>
              </b-table-column>
              <b-table-column label="Source"
                              field="source"
                              width="20%"
                              style="text-align: left" sortable>
                <span >{{ getFormattedSource(row['source']) }}</span>
              </b-table-column>
            </template>
            <template #bottom-left>
              <div class="modern-input-labeled">
                <label class="per-page"
                       style="font-weight: 700; white-space: nowrap">
                  Per page
                </label>
                <ModernSelect
                    style="margin-right: 1em"
                    v-model="filters.limit"
                    :options="perPageOptions"
                />
              </div>
            </template>
            <template #empty v-if="!loading">
              <div style="padding-top: 1em; overflow: hidden; text-align: center">
          <span class="icon">
            <i class="fal fa-frown fa-3x"></i>
          </span>
                <p>Nothing here</p>
              </div>
            </template>
          </ModernTable>
        </template>
      </section>
    </div>
</template>


<script>
import { getUnsubscribers } from '@/api/emails';
import { mapGetters } from 'vuex';
import Vue from 'vue';
import EmailUnsubscribers from '@/components/Modal/EmailUnsubscribers.vue';
import ModernInput from '@/components/ModernInput.vue';
import ModernSelect from '@/components/ModernSelect.vue';
import ModernTable from '@/components/ModernTable.vue';
import { pick } from 'lodash';

export default {
  name: 'EmailUnsubscribers',
  components: {
    ModernInput,
    ModernSelect,
    ModernTable,
  },

  data() {
    return {
      isFormDisabled: false,
      isTopSticky: false,
      filters: {
        searchText: '',
        source: '',
        page: 1,
        limit: 25,
        sortField: 'date',
        sortOrder: 'desc',
      },
      columns: [
        {
          field: 'email',
          label: 'E-mail',
          sortable: true,
          width: 150,
        },
        {
          field: 'date',
          label: 'Date',
          sortable: true,
          width: 80,
        },
        {
          field: 'source',
          label: 'Source',
          sortable: true,
          width: 80,
        },
      ],
      data: [],
      roles: [],
      total: 0,
      page: 1,
      perPageOptions: [{ value: 10 }, { value: 25 }, { value: 50 }, { value: 100 }],
      sources: [
        { key: 'default', value: '' },
        { key: 'close', value: 'Close' },
        { key: 'manual', value: 'Manual' },
        { key: 'do_not_contact', value: 'Do not contact' },
      ],
      loading: false,
    };
  },

  mounted() {
    this.loadAsyncData();
  },

  computed: {
    ...mapGetters(['authAuthenticator']),
    pageOrderParams() {
      return JSON.stringify(pick(this.filters, ['page', 'sortOrder', 'sortField', 'source']));
    },
  },
  watch: {
    pageOrderParams() {
      this.loadAsyncData();
    },
    'filters.limit': 'doSearch',
  },
  methods: {
    onSort(field, order) {
      this.filters.sortField = field;
      this.filters.sortOrder = order;
      this.loadAsyncData();
    },
    async onUnsubscribe() {
      const Component = Vue.extend(EmailUnsubscribers);
      await this.$buefy.modal.open({
        parent: this,
        component: Component,
        hasModalCard: true,
        trapFocus: true,
        scroll: 'keep',
        ariaModal: true,
        customClass: 'card-form-modal',
        canCancel: ['outside'],
        props: {
          unsubscribe: true,
        },
        events: {
          async submit(response) {
            const { context } = response;
            const vue = context.$parent.$parent;
            await vue.loadAsyncData();
            vue.toast('Unsubscribe successful!');
          },
        },
      });
      this.changeModalPosition();
    },
    async onResubscribe() {
      const Component = Vue.extend(EmailUnsubscribers);
      await this.$buefy.modal.open({
        parent: this,
        component: Component,
        hasModalCard: true,
        trapFocus: true,
        scroll: 'keep',
        ariaModal: true,
        customClass: 'card-form-modal',
        canCancel: ['outside'],
        events: {
          async submit(response) {
            const { context } = response;
            const vue = context.$parent.$parent;
            await vue.loadAsyncData();
            vue.toast('Resubscribe successful!');
          },
        },
      });
      this.changeModalPosition();
    },
    changeModalPosition() {
      const grid = document.querySelector('.grid-module');
      const modal = document.querySelector('.modal');
      if (grid && modal) grid.insertAdjacentElement('beforeend', modal);
    },
    toast(message, type = 'is-success') {
      this.$buefy.toast.open({ message, type, duration: 5000 });
    },


    loadAsyncData() {
      this.loading = true;
      const queryParams = {
        page: this.filters.page,
        limit: this.filters.limit,
        order: `${this.filters.sortOrder === 'desc' ? '-' : '+'}${this.filters.sortField}`,
        filters: {
          email: this.filters.searchText.trim(),
        },
      };
      if (this.filters.source) {
        const item = this.sources.find((el) => el.value === this.filters.source);
        queryParams.filters.source = item.key;
      }
      getUnsubscribers(queryParams).then((response) => {
        this.data = [];
        this.data = response.data.data;
        this.total = response.data.total;
      }).finally(() => { this.loading = false; });
    },
    async doSearch() {
      this.loadAsyncData();
    },
    getFormattedSource(source) {
      const item = this.sources.find((el) => el.key === source);
      if (item) {
        return item.value;
      }
      return '';
    },
  },
};
</script>

<style lang="stylus" scoped>
@require "../assets/style/modern/variables.styl";

.sm-show
  display none
.sm-flex-column
  min-width 100%
.grid-module__filter
  padding 10px 0 20px

.floating-button
  margin-left auto
  margin-right 0
  display flex
  gap 10px

.email-column::before
  width fit-content
  white-space nowrap
  margin-right 10px

@media (max-width: $breakpoints.md)
  .modern-form-group > *
    margin-right 0
  .sm-hide
    display none
  .sm-show
    display block
  .floating-button
    width 100%
    flex-wrap wrap
    button
      width 100%
  .modern-input-controlled
    width 100%


@media (max-width: $breakpoints.lg)
  .sm-modern-form-group
    margin-bottom 0
    padding-bottom 0
  .hide-label
    display none
  .report-table__applicant-column
    width 180px

.table.modern-table-table tr td,.b-table.modern-table >>> tr th
  vertical-align middle
  @media (min-width: $breakpoints.md) and (max-width: $breakpoints.lg)
    font-size 16px!important
  @media (max-width: $breakpoints.md)
    font-size 14px!important
</style>
